import { useEffect, useState } from "react"
import { ConcepItem } from "./ConcepItem";
import { SpanRender } from "../../../../../theme/Component/SpanRender";
import { MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { InputMoney } from "../../../../../theme/Input/InputMoney";

interface Props {
    discountValue: number,
    PaidValues: any,
    conceptCodes: any,
    credit: any

}
export const PaymentApply = ({ discountValue, PaidValues, conceptCodes, credit }: Props) => {

    const [concepts, setConsepts] = useState<any>([]);
    const [modelo, setModelo] = useState<any>(1);
    const [cxc,setCXC] = useState<any>(null);
    const [paymentModels, setPaymntModels] = useState<any>(
        [
            { id: 1, name: "Cuenta de Cobro",enable:cxc},
            { id: 2, name: "Primero Interes",enable:true },
            { id: 3, name: "Primero Capital",enable:true },
            { id: 4, name: "Manual" ,enable:true},
        ]
    )
    const [values, setValues] = useState<any>({
        sobrante: 0,
        interesVencido: 0,
        interesCorriente: 0,
        capitalCorriente: 0,
        capitalVencido: 0,
        transitoria: 0,
    });

    useEffect(() => {
        if (conceptCodes)
            setConsepts(conceptCodes);
    }, [conceptCodes])
   
    useEffect(() => {
        if (credit)
        {
            if(credit.PaidedData)
                setModelo(1);
            else{
                setModelo(2);
            }
            setCXC(credit.PaidedData);
            setDistribution();
        }
    }, [credit])

    const setDistribution=()=>{

    }

    const updateConcept = (co) => {
        console.log(co);

    }

    return (
        <div className="row">

             <div className="col-md-12">
                <label>Modelo de abono</label>
                <select name="modelo" id="modelo" className="form-select" >
                    {paymentModels.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.id} disabled={!item.enable}>{item.name}</option>
                        )
                    })}
                </select>
            </div>

            <div className="col-md-4">
                <label>Cuota</label>
                <div className="form-control">
                    <SpanRender mask={MASK_MONEY} value={credit.ValorCuota} />
                </div>
            </div>
            <div className="col-md-4">
                <label>Pago / Abono</label>
                <div className="form-control">
                    <SpanRender mask={MASK_MONEY} value={discountValue} />
                </div>
            </div>
            <div className="col-md-4">
                <label>SaldoCapital</label>
                <div className="form-control">
                    <SpanRender mask={MASK_MONEY} value={credit.SaldoCapital} />
                </div>
            </div>
           
            <div className="col-md-6 mt-4">
                <strong>Capital</strong><hr />
                <div className="row">
                    <div className="col-12">                        
                        <InputMoney _label="Corriente" _value={values.capitalCorriente} onChange={(e) => {setValues({...values,"capitalCorriente":e}) }} readonly />
                    </div>
                    <div className="col-12">                        
                        <InputMoney _label="Vencido" _value={values.capitalVencido} onChange={(e) => {setValues({...values,"capitalVencido":e})  }} readonly />
                    </div>                   
                    <div className="col-12">                        
                        <InputMoney _label="Sobrante" _value={values.sobrante} onChange={(e) => {setValues({...values,"sobrante":e})  }} readonly />
                    </div>                   
                </div>
            </div>
            <div className="col-md-6 mt-4">
               <strong>Interes</strong><hr />
                <div className="row">
                    <div className="col-12">                        
                        <InputMoney _label="Corriente" _value={values.interesCorriente} onChange={(e) => {setValues({...values,"interesCorriente":e})  }} readonly />
                    </div>
                    <div className="col-12">                        
                        <InputMoney _label="Vencido" _value={values.interesVencido} onChange={(e) => {setValues({...values,"interesVencido":e})  }} readonly />
                    </div>                   
                </div>
            </div>
           

            {/* <div className="col-md-12">
                <div className="row">
                    {concepts.map((row: any, index: number) => (
                        <div className="col-md-6">
                            <ConcepItem key={index} item={row.DataBeanProperties} onChange={updateConcept} />
                        </div>
                    ))}
                </div>
            </div> */}
            <div className="col-md-12">
                <PrintJson json={credit} />
            </div>
        </div>
    )
}